import { useLocalization } from '@ais-ui/locale-management';
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  Switch,
} from '@ais-ui/ui-core';
import { cn } from '@ais-ui/utils';
import { UseFormReturn } from 'react-hook-form';
import { AdminFormValues } from './useAdminForm';

interface AdminFormProps {
  form: UseFormReturn<AdminFormValues>;
}

export function AdminForm({ form }: AdminFormProps) {
  const { messages } = useLocalization();

  return (
    <Form {...form}>
      <div className="space-y-12">
        {/* Target Settings Section */}
        <div className="space-y-4">
          <h3 className="text-lg font-medium">
            {messages.settingsAdminTargetTitle}
          </h3>
          <div className="space-y-4">
            <FormField
              control={form.control}
              name="showTargetCountBadge"
              render={({ field }) => (
                <FormItem
                  className={cn(
                    'flex flex-row items-center justify-between border rounded-lg p-4'
                  )}
                >
                  <div className="space-y-0.5">
                    <FormLabel className="text-base">
                      {messages.settingsAdminTargetCountBadgeLabel}
                    </FormLabel>
                    <FormDescription>
                      {messages.settingsAdminTargetCountBadgeDescription}
                    </FormDescription>
                  </div>
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                      id="target-count-badge-switch"
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>
      </div>
    </Form>
  );
}
